import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";

const CellTextField = ({ inputValue, onChange, index, type, isDisabled=false }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (inputValue !== value) setValue(inputValue);
  }, [inputValue]);

  const changeValue = (e) => {
    if (index > -1) {
      setValue(e.target.value);
      onChange(e.target.value, index, type);
    }
  };

  return <Textfield value={value} isCompact onChange={changeValue} isDisabled={isDisabled}/>;
};

export default CellTextField;
